module.exports = __webpack_public_path__ + "img/all.cf027aac.png";